/**
 * SHARED LEGACY UTILITY
 *
 * This hook is used by multiple apps split from LearningCenterUI.
 * It does not belong to any single app — each app that needs it
 * imports this shared copy.
 *
 * The .legacy suffix exists to preserve git history transfer.
 */
import { useEffect } from 'react';
import I18n from 'I18n';
const decodeHTMLEntities = text => {
  const doc = new DOMParser().parseFromString(text, 'text/html');
  return doc.documentElement.textContent || '';
};
const setDocumentTitleDecoded = (key, options) => {
  void I18n.Info.then(() => {
    const title = I18n.text(key, options);
    document.title = decodeHTMLEntities(title);
  });
};
export const usePageTitle = params => {
  const {
    i18nKey,
    options,
    isRouteTitle = false,
    skip = false
  } = params || {};
  useEffect(() => {
    if (skip || !i18nKey) return;
    if (isRouteTitle) {
      setDocumentTitleDecoded(i18nKey, options);
    } else {
      const timeoutId = setTimeout(() => setDocumentTitleDecoded(i18nKey, options), 0);
      return () => clearTimeout(timeoutId);
    }
  }, [i18nKey, options, isRouteTitle, skip]);
};